import { fetchMtrStructMainList } from '#/api/imsMgmt/settings/mtrStruct/main/fetchList';

export function mapMainRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: `${row.code} - ${row.name}`,
  }));
}

export async function fetchMtrStructMainSelectOptions() {
  const { data } = await fetchMtrStructMainList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters: {},
  });

  return mapMainRowsToSelectOptions(data);
}
